import React from 'react';
import { Form, Input, Button,Spin } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;



var token= ''
var sacco= ''


class CurrencyForm extends React.Component {

  state = {
    currency_name:'' ,  
    description:'',
    datarequested:false,
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }
  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('currency_name', this.state.currency_name);
    form_data.append('description', this.state.description);
    form_data.append('sacco', sacco);

      axios.post(serverconfig.backendserverurl+'/api/currencies/', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res =>     this.setState({datarequested:false})
,    window.location.reload(false)
    )
    .catch(error => console.log(error))

  }

  handlecurrency_nameChange= (e) => this.setState({ currency_name: e.target.value});
  handleIDDescriptionChange= (e) => this.setState({ description: e.target.value});

  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="Currency Code"
        name="idname"
        rules={[
          {
            required: true,
            message: 'Please input code',
          },
        ]}
      >
        <Input name="currency_name"  placeholder="Put a code here." value={this.state.currency_name} onChange={this.handlecurrency_nameChange} />
      
      </FormItem>
      <FormItem label="Description"
        name="description"
        rules={[
          {
            required: true,
            message: 'Please input desc',
          },
        ]}    
      >
        <Input name="description"  placeholder="Description here" value={this.state.description} onChange={this.handleIDDescriptionChange} />
      </FormItem>
     
      <FormItem>
        <Button  type="primary" htmlType="submit">{this.props.btnText}</Button>
      </FormItem>
    </Form>
        </div>
      );

    }

   
  }

}


export default CurrencyForm;



